import { NotificationsScreen } from '../features/notifications/NotificationsScreen'
import { useShell } from '../app/outlet'
import { env } from '../config/env'
import { NotFoundPage } from './NotFoundPage'

/** Флаг `VITE_FEATURE_NOTIFICATIONS` выключен — раздела нет, адрес ведёт в «не найдено». */
export function NotificationsPage() {
  const { toast } = useShell()
  return env.features.notifications ? <NotificationsScreen onToast={toast} /> : <NotFoundPage />
}
